import { select } from 'helpers/dom'

const selectors = {
  EMBLA_CAROUSEL_SELECTOR: 'carousel-embla.js-carousel-blog-nav',
  ITEM_CURRENT_SELECTOR: '.js-current-item'
}

class BlogNav extends HTMLElement {
  constructor() {
    super()

    this.emblaCarouselEl = select(selectors.EMBLA_CAROUSEL_SELECTOR, this)

    const emblaApi = this.emblaCarouselEl?.instance?.emblaApi
    const activeIndex = select(selectors.ITEM_CURRENT_SELECTOR, this)?.getAttribute('data-index')

    if (!this.emblaCarouselEl || !emblaApi || activeIndex === null) {
      return
    }

    emblaApi.scrollTo(parseInt(activeIndex, 10), true)
  }
}

if (!customElements.get('blog-nav')) {
  customElements.define('blog-nav', BlogNav)
}
